import React from "react";
import PropTypes from "prop-types";
//Material imports
import withStyles from "@mui/styles/withStyles";
//Limitless imports
import { withi18n } from "../../../../customer/components";
import Typography from "@limitless/modern/data-display/typography/Typography";
import { useMessageFlag } from "../../../../expert";
import Dialog from "@limitless/modern/feedback/dialog/Dialog";
const MessageConversationCompleteDialog = ({
  onCancel
}) => {
  const {
    sendCustomerCompleteFlag
  } = useMessageFlag();
  const handleOkClick = () => {
    onCancel();
    sendCustomerCompleteFlag();
  };
  return /*#__PURE__*/React.createElement(Dialog, {
    open: true,
    onClose: onCancel,
    "aria-labelledby": "confirmCC",
    id: "confirmCC",
    title: "Conversation Complete",
    onOkClick: () => handleOkClick(),
    onCancelClick: () => onCancel(false),
    okText: "Confirm",
    cancelVariant: "text",
    cancelText: "cancel",
    paperStyle: {
      maxWidth: "452px"
    }
  }, /*#__PURE__*/React.createElement(Typography, {
    variant: "body2",
    color: "text.primary"
  }, "Are you sure you want to mark this conversation as complete?"), /*#__PURE__*/React.createElement(Typography, {
    variant: "body2",
    color: "text.primary"
  }, "This will prompt the customer to accept and rate their experience."));
};
const styles = () => ({
  container: {
    background: "transparent"
  },
  paper: {
    width: 480
  }
});
export default withStyles(styles)(withi18n(MessageConversationCompleteDialog));
MessageConversationCompleteDialog.propTypes = {
  classes: PropTypes.object.isRequired,
  t: PropTypes.func.isRequired,
  onCancel: PropTypes.func.isRequired
};